import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { isFavorite, toggleFavorite, pushHistory, type PrayerLink } from "@/lib/prayer/favorites";
import { toast } from "sonner";
import type { Location } from "@/data/locations";
import type { PrayerVariant } from "@/lib/seo/prayer-schema";
import { displayLocationTitle } from "@/lib/prayer/copy";

function schedulePath(variant: PrayerVariant, location: Location): string {
  const base = variant === "buka-puasa" ? "/jadwal-buka-puasa" : `/jadwal-${variant}`;
  return location.kind === "kecamatan"
    ? `${base}/${location.parentSlug}/${location.slug}`
    : `${base}/${location.slug}`;
}

export function FavoriteButton({ variant, location }: { variant: PrayerVariant; location: Location }) {
  const display = displayLocationTitle(location);
  const link: PrayerLink = {
    variant, slug: location.kind === "kecamatan" ? location.parentSlug! : location.slug,
    kecSlug: location.kind === "kecamatan" ? location.slug : undefined,
    name: display,
    href: schedulePath(variant, location),
  };
  const [fav, setFav] = useState(false);

  useEffect(() => {
    setFav(isFavorite(link));
    pushHistory(link);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [variant, location.slug]);

  function onClick() {
    const next = toggleFavorite(link);
    setFav(next);
    toast.success(next ? `${display} ditambahkan ke favorit` : `${display} dihapus dari favorit`);
  }

  return (
    <Button variant={fav ? "default" : "outline"} size="sm" onClick={onClick} className={fav ? "bg-prayer text-prayer-foreground hover:bg-prayer/90" : ""}>
      <Star className={`mr-2 h-4 w-4 ${fav ? "fill-current" : ""}`} />
      {fav ? "Favorit" : "Tambah ke Favorit"}
    </Button>
  );
}
